<template>
    <div>
        <div style="display: flex; justify-content: space-around">
            <div class="imgBox">
                <span class="imgTitle">手持正面照</span>
                <ImgView :src="identityForm.imgZ" size="600px"/>
            </div>
            <div class="imgBox">
                <span class="imgTitle">身份证正面照</span>
                <ImgView :src="identityForm.imgF" size="600px"/>
            </div>

        </div>
    </div>

</template>

<script>
    import ImgView from "@/views/auth/components/ImgView";
    import { postFormData, getFormData } from "../../../../api/api";
    import { updateIdentityState, getPlainInfo } from "../../../../api/url";

    export default {
        name: "IdentityExamine",
        components: { ImgView },
        props: {
            value: Object
        },
        data() {
            return {
                identityForm: this.value.identityForm,
                uid: this.value.uid,
                isFast: this.value.isFast,
                isShow: 1,
                checkList:[1,2],
                state: 1,
                regAgain: this.value.identityForm.isRepeat == 1 ? true : false,
                identitySubLoading: false,
            }
        },
        methods: {
            //返回
            cancel() {
                this.$emit('close');
            },

            getPlan(type, subType) {
                let param = {}
                param['uid'] = this.uid;
                param['type'] = type;
                param['subType'] = subType;
                getFormData( getPlainInfo, param ).then((data)=>{
                    let {code, msg} = data;
                    if( code == 200 ) {
                        this.identityForm.identityCode = data.data.identityCode
                        this.identityForm.imgF = data.data.identityImgF
                        this.identityForm.imgZ = data.data.identityImgZ
                    } else {
                        this.$message({
                            showClose: true,
                            duration: 1000,
                            message: msg,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{

                })
            },

        },
        mounted(){
            this.getPlan(12, 0)
        }
    }
</script>

<style scoped>
.imgBox {
    position: relative;
}
.imgTitle {
    margin-left: 16px;
    background-color: #409eff;
    color: #ffffff;
    padding: 6px 12px;
    font-weight: bold;
    position: absolute;
    top: 0;
    z-index: 99;
    border-bottom-right-radius: 8px;
}
</style>
